<template>
  <div class="loc-manual-location">
    <generic-modal
      :height="LocationModalDim.height"
      :width="LocationModalDim.width"
      :padding="LocationModalDim.padding"
      :modalClass="LocationModalDim.modalClass"
      :overflowNotNeeded="0"
    >
      <template v-slot:header>
        <search-location-header :modulePropsData="modulePropsData" />
      </template>
      <template v-slot:body v-if="!isInvalidSearchInput">
        <!-- <div
          class="divider-lg"
          v-if="displayCurrentLocation && !isAutocompletePredictionVisible"
        ></div> -->
        <!-- commented your current location segment -->
        <!-- <div
          v-if="displayCurrentLocation && !isAutocompletePredictionVisible"
          class="pt20 pb20"
          :class="[clientPlatform !== 'Web' ? 'plr16' : '']"
        >
          <div class="bold fs-14">Your Current Location</div>
          <div class="font-default fs-12 color-slaty mt2">
            {{ displayCurrentLocation }}
          </div>
        </div> -->
        <div
          v-if="autoCompletePredictionAddresses?.length > 0"
          class="search-list-container"
        >
          <reusable-list
            v-if="autoCompletePredictionAddresses?.length > 0"
            :items="autoCompletePredictionAddresses"
            :mainTextKey="SearchPredictionsListKeys.mainTextKey"
            :subTextKey="SearchPredictionsListKeys.subTextKey"
            :commanItemIconClass="SearchPredictionsListKeys.commanItemIconClass"
            :listTitle="SearchPredictionsListKeys.listTitle"
            :className="SearchPredictionsListKeys.listClassName"
            :listItemClass="SearchPredictionsListKeys.listItemClass"
            :listItemSubClass="SearchPredictionsListKeys.listItemSubClass"
            :onClick="searchResultListItemClick"
            :highlightText="highlightSearchedText"
          />
          <div class="border-top mr16 pt16">
            <div class="fs-14 tc color-slaty">
              <p>
                {{ getCannotFindText }}
              </p>
              <p>
                {{ getTrySearchingText }}
              </p>
            </div>
            <button
              class="mt12 fs-14 bold btn w100 primary d-flex align-items-center justify-content-center"
              @click="getCurrentLocation($event)"
            >
              <i class="hkfi-map-icon fs-20 mr8" />{{ getLocateOnMapText }}
            </button>
          </div>
        </div>
        <!-- <div
          class="divider-lg mt20"
          v-if="
            displayCurrentLocation &&
            !isAutocompletePredictionVisible &&
            savedAddresses?.length > 0 &&
            displaySavedAddresses &&
            checkDeliveryTypeIsD
          "
        ></div> -->
        <no-saved-address
          v-if="!savedAddresses?.length && !isAutocompletePredictionVisible"
          :data-message="noSavedAddressHeadingText"
          :data-cta-text="noSavedAddressCTAText"
          :data-image="noSavedAddressImgUrl"
          :data-cta-click-handler="
            isLoggedIn ? handleAddNewAddressClick : handleLoginClick
          "
          :small-component="true"
        />
        <reusable-list
          v-if="
            savedAddresses?.length > 0 &&
            checkDeliveryTypeIsD &&
            displaySavedAddresses &&
            !isAutocompletePredictionVisible &&
            !getIsAddEditAddressFlow
          "
          :items="savedAddresses"
          :editableMenuItems="
            isLoggedIn
              ? editableSavedAdressMenuItems
              : editableSavedAdressMenuItemsForGuestUser
          "
          :className="SavedAddressesListKeysForMannualLocation.className"
          :mainTextKey="SavedAddressesListKeysForMannualLocation.mainTextKey"
          :subTextKey="SavedAddressesListKeysForMannualLocation.subTextKey"
          :itemIconKey="SavedAddressesListKeysForMannualLocation.itemIconKey"
          :listTitle="SavedAddressesListKeysForMannualLocation.listTitle"
          :editableIconClass="
            SavedAddressesListKeysForMannualLocation.editableIconClass
          "
          :listTitleClass="
            SavedAddressesListKeysForMannualLocation.listTitleClass
          "
          :titleRightButtonClass="
            SavedAddressesListKeysForMannualLocation.titleRightButtonClass
          "
          :titleRightButton="
            SavedAddressesListKeysForMannualLocation.titleRightButton
          "
          :listItemClass="
            SavedAddressesListKeysForMannualLocation.listItemClass
          "
          :handleRightButtonClick="handleAddNewAddressClick"
          :onClick="reusableListOnClick"
          :destination="'location'"
          :displayEditableIconMenu="true"
          :listName="'addresses'"
          :marginClass="'p12'"
          :listItemBorderDisabled="
            SavedAddressesListKeysForMannualLocation.listItemBorderDisabled
          "
          :showVeiwMore="true"
          :viewMoreEnableLimit="
            SavedAddressesListKeysForMannualLocation.viewMoreEnableLimit
          "
          :listContentWrapperClass="
            SavedAddressesListKeysForMannualLocation.listContentWrapperClass
          "
          :displayDistance="true"
          :currentLocationCoords="currentLocationCoords"
          :selectedIndex="getSelectedAddressIndex"
        />
        <!-- <div
          class="divider-lg mt20"
          v-if="
            recentSearchedList?.length > 0 &&
            !isAutocompletePredictionVisible &&
            (displayCurrentLocation ||
              (displaySavedAddresses && savedAddresses?.length > 0))
          "
        /> -->
        <reusable-list
          v-if="
            recentSearchedList?.length > 0 && !isAutocompletePredictionVisible
          "
          :className="RecentSearchListKeys.className"
          :items="recentSearchedList"
          :mainTextKey="RecentSearchListKeys.mainTextKey"
          :subTextKey="RecentSearchListKeys.subTextKey"
          :commanItemIconClass="RecentSearchListKeys.commanItemIconClass"
          :listTitle="RecentSearchListKeys.listTitle"
          :listTitleClass="RecentSearchListKeys.listTitleClass"
          :titleRightButtonClass="RecentSearchListKeys.titleRightButtonClass"
          :titleRightButton="RecentSearchListKeys.titleRightButton"
          :handleRightButtonClick="clearRecentSearchedLocation"
          :onClick="recentSearchResultListItemClick"
          :listItemBorderDisabled="RecentSearchListKeys.listItemBorderDisabled"
          :marginClass="'pl8'"
        />
      </template>
      <template v-slot:body v-else>
        <invalid-search-results
          :data-message="invalidSearchResultsDetailsNoLocationsSubtitle"
          :data-title="invalidSearchResultsDetailsNoLocationsTitle"
          :data-cta-text="invalidSearchResultsDetailsCtaText"
          :data-cta-icon="invalidSearchResultsDetailsCtaIcon"
          :data-image="invalidSearchResultsDetailsNoLocationImage"
          :data-cta-click-handler="getCurrentLocation"
        />
      </template>
      <template v-slot:footer />
    </generic-modal>
    <generic-modal
      v-if="showDeleteModal"
      @close="closeDeleteModal()"
      :height="deleteAddressModalDim.height"
      :width="deleteAddressModalDim.width"
      :modalClass="deleteAddressModalDim.modalClass"
      :bottom="deleteAddressModalDim.bottom"
      :paddingBottom="deleteAddressModalDim.paddingBottom"
      :background="deleteAddressModalDim.background"
      :headerBackground="deleteAddressModalDim.background"
      :backgroundBody="deleteAddressModalDim.backgroundBody"
      :animationStyle="deleteAddressModalDim.animationStyle"
    >
      <template v-slot:header>
        <img
          :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
          class="handle-bg"
        />
      </template>
      <template v-slot:body>
        <div class="fs-16 plr16 pb12 pt12 border-bottom bold">
          {{ getDeleteAddressHeadingText }}
          “{{ deleteAddressTitle }}”?
        </div>
        <div class>
          <div class="btns">
            <button
              class="btn secondary fs-14 fw-700"
              v-on:click="confirmDelete()"
            >
              {{ getDeleteAddressDeleteText }}
            </button>
            <button
              class="btn primary fs-14 fw-700"
              v-on:click="closeDeleteModal()"
            >
              {{ getDeleteAddressCancelText }}
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </generic-modal>
    <notify-toast-message />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import get from "lodash/get";
import SearchLocationHeader from "./SearchLocationHeader.vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../helpers/storeKeys";
import {
  SavedAddressesListKeysForMannualLocation,
  SearchPredictionsListKeys,
  RecentSearchListKeys,
  LocationPageStaticKeys,
  NewLocationPopupPermissionTextData,
} from "../helpers/addressConstants";

import {
  imgBaseUrl,
  staticImgBaseUrl,
  clientPlatform,
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { OrderTypesCode } from "../helpers/orderTypesConstants";
import {
  EVENT_LOCATION_CLICK,
  EVENT_LOCATION_ADDRESS_INPUT,
} from "../helpers/analyticsEvents";

import NotifyToastMessage from "./NotifyToastMessage.vue";

export default {
  name: "ManualLocation",
  components: {
    SearchLocationHeader,
    GenericModal,
    ReusableList: defineAsyncComponent(() => import("./ReusableList.vue")),
    NoSavedAddress: defineAsyncComponent(() => import("./NoSavedAddress.vue")),
    InvalidSearchResults: defineAsyncComponent(() =>
      import("./InvalidSearchResults.vue")
    ),
    NotifyToastMessage,
  },
  props: ["modulePropsData"],
  data() {
    return {
      get,
      clientPlatform,
      LocationModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "location-modal manual-location-modal",
      },
      SavedAddressesListKeysForMannualLocation,
      SearchPredictionsListKeys,
      RecentSearchListKeys,
      LocationPageStaticKeys,
      staticImgBaseUrl,
      deleteAddressModalDim: {
        height: "100vh",
        width: "100%",
        modalClass: "full-screen-popup lg-screen-centered delete-address-modal",
        background: "transparent",
        backgroundBody: "white",
        animationStyle: "slide-up-stick-bottom",
      },
      showDeleteModal: false,
      deleteAddressId: "",
      deleteAddressTitle: "",
      OrderTypesCode,
    };
  },
  mounted() {
    this.checkIfDesktop();
    this.apiCallsForUser();
  },
  destroyed() {
    if (document.body.classList.contains("hide-header-footer")) {
      document.body.classList.remove("hide-header-footer");
    }
  },
  methods: {
    checkIfDesktop() {
      if (this.clientPlatform == "Web") {
        document.body.classList.add("hide-header-footer");
      }
    },
    apiCallsForUser() {
      this.$store.dispatch(keyMapsAction.SAVED_ADDRESSES_API);
    },
    searchResultListItemClick(item, index) {
      document.body.classList.remove("hide-header-footer");
      LocalStorageFunc.updateRecentSearchedLocationList(item);
      EVENT_LOCATION_CLICK({
        sectionName: "address selection",
        sectionPosition: 2,
        positionWithinSection: index + 1,
        category: "locality selected from search result",
        subcategory: item,
      });
      EVENT_LOCATION_ADDRESS_INPUT({
        userAction: "user selects address",
        sectionName: "change location",
        sectionPosition: 2,
        positionWithinSection: index + 1,
        category: "manual input",
        subcategory: "selected from suggestion",
      });

      if (
        this.isChangeTriggeredFromTakeawayDinein &&
        !this.getIsAddEditAddressFlow
      ) {
        // LocalStorageFunc.resetAllSelectedLocations();
        LocalStorageFunc.setSelectedChangedLocationForTwyDinein(item);
        let query = {
          place_id: item.placeId,
        };
        this.$store.dispatch(keyMapsAction.GEO_CODE_API, query).then((res) => {
          if (res.data.status === "SUCCESS") {
            if (res.data?.results[0]) {
              let pos = res.data.results[0].geometry.location;
              this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
                latitude: pos.lat,
                longitude: pos.lng,
              });

              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
                false
              );
              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
                false
              );

              LocalStorageFunc.updateLastLocationOnConfirmedLocation();
              if (this.getIsAddEditAddressFlow) {
                this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, {
                  lat: pos.lat,
                  lng: pos.lng,
                });
                Utility.sendToSaveAddressScreen(window.location);
              }
            }
          }
        });
      } else {
        if (this.getIsAddEditAddressFlow) {
          item = {
            ...item,
            redirectTo: () => this.handleSetAddAddressFlow(),
          };
        }
        this.showSelectedLocationOnMap(item);
        if (!LocalStorageFunc.getIsLocationPermisssionGiven()) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
            true
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_ALTERNATE_LOCATION_POPUP_DATA,
            {
              ...NewLocationPopupPermissionTextData,
              secondaryCTAText: `Continue With ${get(
                item,
                this.SearchPredictionsListKeys.mainTextKey,
                item
              )}`,
              onSecondaryCTACloseDialog: true,
            }
          );
        }
      }
    },
    recentSearchResultListItemClick(item, index) {
      document.body.classList.remove("hide-header-footer");
      LocalStorageFunc.updateRecentSearchedLocationList(item);
      if (
        this.isChangeTriggeredFromTakeawayDinein &&
        !this.getIsAddEditAddressFlow
      ) {
        // LocalStorageFunc.resetAllSelectedLocations();
        LocalStorageFunc.setSelectedChangedLocationForTwyDinein(item);
        let query = {
          place_id: item.placeId,
        };
        this.$store.dispatch(keyMapsAction.GEO_CODE_API, query).then((res) => {
          if (res.data.status === "SUCCESS") {
            if (res.data?.results[0]) {
              let pos = res.data.results[0].geometry.location;
              this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
                latitude: pos.lat,
                longitude: pos.lng,
              });

              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
                false
              );
              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
                false
              );

              LocalStorageFunc.updateLastLocationOnConfirmedLocation();
              if (this.getIsAddEditAddressFlow) {
                this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, {
                  lat: pos.lat,
                  lng: pos.lng,
                });
                Utility.sendToSaveAddressScreen(window.location);
              }
            }
          }
        });
      } else {
        if (this.getIsAddEditAddressFlow) {
          item = {
            ...item,
            redirectTo: () => this.handleSetAddAddressFlow(),
          };
        }
        this.showSelectedLocationOnMap(item);
        if (!LocalStorageFunc.getIsLocationPermisssionGiven()) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
            true
          );

          this.$store.commit(
            keyMapsMutation.UPDATE_ALTERNATE_LOCATION_POPUP_DATA,
            {
              ...NewLocationPopupPermissionTextData,
              secondaryCTAText: `Continue With ${get(
                item,
                this.RecentSearchListKeys.mainTextKey,
                item
              )}`,
              onSecondaryCTACloseDialog: true,
            }
          );
        }
      }
    },
    showSelectedLocationOnMap(item) {
      let query = {
        place_id: item.placeId,
        showDeliveryMapScreen: true,
        redirectTo: item?.redirectTo,
      };
      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, query);
      // this.$store.commit(keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN, true);
      // this.$store.dispatch(keyMapsAction.GEO_CODE_API, query).then((res) => {
      //   if (res.data.status === "SUCCESS") {
      //     if (res.data?.results[0]) {
      //       let pos = res.data.results[0].geometry.location;
      //       let position = {
      //         coords: {
      //           latitude: pos.lat,
      //           longitude: pos.lng,
      //         },
      //         disableStoreFromRecentLocation: true,
      //       };
      //       this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      //       this.$store.commit(
      //         keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
      //         true
      //       );
      //       this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
      //       this.$store.commit(
      //         keyMapsMutation.UPDATE_GOOGLE_ADDRESS_COMPONENT,
      //         res.data?.results[0]
      //       );
      //     }
      //   }
      // });
    },
    reusableListOnClick(item, index) {
      document.body.classList.remove("hide-header-footer");
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS, item);
      LocalStorageFunc.setLocalStorageValue("selectedAddress", item);
      let pos = {
        lat: item.latitude,
        lng: item.longitude,
      };
      EVENT_LOCATION_CLICK({
        sectionName: "address selection",
        sectionPosition: 3,
        positionWithinSection: index + 1,
        category: "saved address",
        subcategory: item.customer_address_name,
      });
      let position = {
        coords: {
          latitude: pos.lat,
          longitude: pos.lng,
        },
        redirectTo: this.getIsAddEditAddressFlow
          ? Utility.sendToSaveAddressScreen(window.location)
          : Utility.redirectToHomeOrRedirectUrl,
        homePageAddress: {
          topAddress: item.customer_address_name,
          bottomAddress: item.formatted_address,
        },
      };
      if (item.address_id) {
        position.deliveryAddressId = item.address_id;
      }
      LocalStorageFunc.setComputedLocationData(position.homePageAddress);
      LocalStorageFunc.setDeliveryType("D");
      LocalStorageFunc.setToastNotifications({
        msg: "Address changed successfully!",
      });
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
      if (this.getIsAddEditAddressFlow) {
        Utility.sendToSaveAddressScreen(window.location);
      }
    },
    handleEditClick(item) {
      LocalStorageFunc.setEditAddresEnable(item);
      LocalStorageFunc.setIsAddEditAddressFlow(true);
      LocalStorageFunc.setIsRedirectedFrom("/location");
      LocalStorageFunc.deleteLocationChangedAddress();
      Utility.sendToSaveAddressScreen(window.location);
    },
    handleDeleteClick(item) {
      this.deleteAddressId = item?.address_id;
      this.deleteAddressTitle = item?.customer_address_name;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    clearRecentSearchedLocation() {
      LocalStorageFunc.clearRecentSearchedLocationList();
      Utility.reloadPage();
    },
    handleAddNewAddressClick() {
      LocalStorageFunc.setAddAddressEnable();
      LocalStorageFunc.setIsAddEditAddressFlow(true);
      LocalStorageFunc.setIsRedirectedFrom("/location");
      if (Utility.isTakeawayOrDineinSelected()) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
          true
        );
        Utility.sendToLocationScreen(window.location);
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
          false
        );
        LocalStorageFunc.setIsAddEditAddressFlow(true);
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
          true
        );
        Utility.sendToLocationScreen(window.location);
        // Utility.sendToSaveAddressScreen(window.location);
      }
    },
    handleLoginClick() {
      Utility.sendToLoginScreen();
    },
    handleSetAddAddressFlow() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        false
      );
      LocalStorageFunc.setIsAddEditAddressFlow(true);
      LocalStorageFunc.setIsChangeAddressTriggeredInAddEditAddressFlow(true);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN, true);
      Utility.sendToLocationScreen(window.location);
    },
    confirmDelete() {
      this.$store.dispatch(keyMapsAction.DELETE_ADDRESS_API, {
        addressId: this.deleteAddressId,
      });
      this.closeDeleteModal();
    },
    getCurrentLocation(e) {
      let currentGPSLocation =
        LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;
      if (!currentGPSLocation) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
          true
        );
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_LOCATION_LOADING, true);
        this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
          showDeliveryMapScreen: true,
          currentLocationDisplay: true,
        });
      }
    },
    //
  },
  computed: {
    getCannotFindText() {
      return (
        this.modulePropsData?.searchLocationDetails?.cannotFindText ||
        this.LocationPageStaticKeys.searchLocationDetails?.cannotFindText
      );
    },
    getTrySearchingText() {
      return (
        this.modulePropsData?.searchLocationDetails?.trySearchingText ||
        this.LocationPageStaticKeys.searchLocationDetails?.trySearchingText
      );
    },
    getLocateOnMapText() {
      return (
        this.modulePropsData?.searchLocationDetails?.locateOnMapText ||
        this.LocationPageStaticKeys.searchLocationDetails?.locateOnMapText
      );
    },
    getDeleteAddressHeadingText() {
      return (
        this.modulePropsData?.deleteAddressPopupTexts?.headingText ||
        this.LocationPageStaticKeys.deleteAddressPopupTexts?.headingText
      );
    },
    getDeleteAddressDeleteText() {
      return (
        this.modulePropsData?.deleteAddressPopupTexts?.deleteText ||
        this.LocationPageStaticKeys.deleteAddressPopupTexts?.deleteText
      );
    },
    getDeleteAddressCancelText() {
      return (
        this.modulePropsData?.deleteAddressPopupTexts?.cancelText ||
        this.LocationPageStaticKeys.deleteAddressPopupTexts?.cancelText
      );
    },
    getSelectedAddressIndex() {
      let selectedSavedAddress = this.$store.state.User.selectedSavedAddress;
      let selectedIndex = -1;
      if (this.savedAddresses.length) {
        this.savedAddresses.map((address, index) => {
          if (address.address_id == selectedSavedAddress.address_id) {
            selectedIndex = index;
          }
        });
      }
      return selectedIndex;
    },
    savedAddresses() {
      return this.$store.getters[keyMapsGetter.GET_REARRANGED_SAVED_ADDRESS]();
    },
    displaySavedAddresses() {
      return this.isLoggedIn || !window?._siteProps_?.props?.requireLoginFlow;
    },
    autoCompletePredictionAddresses() {
      return this.$store.state.Location.autoCompletePredictions;
    },
    isAutocompletePredictionVisible() {
      return this.$store.state.Location.autoCompletePredictions.length > 0;
    },
    highlightSearchedText() {
      return this.$store.state.Location.autoCompleteInput;
    },
    displayCurrentLocation() {
      let currentGPSLocation =
        this.$store.state.Location.currentGPSLocationData;
      return (
        !this.$store.state.Location.autoCompletePredictions.length &&
        currentGPSLocation &&
        currentGPSLocation.footerAddress
      );
    },
    recentSearchedList() {
      return LocalStorageFunc.getRecentSearchedLocationList();
    },
    editableSavedAdressMenuItemsForGuestUser() {
      return [
        {
          label: "Edit",
          labelMethod: (item) => {
            this.handleEditClick(item);
          },
          iconSrc: staticImgBaseUrl + "/images/global/edit-icon.svg",
          iconClass: "hkfi-edit fs-16 color-slaty",
        },
      ];
    },
    editableSavedAdressMenuItems() {
      return [
        {
          label: "Edit",
          labelMethod: (item) => {
            this.handleEditClick(item);
          },
          iconSrc: staticImgBaseUrl + "/images/global/edit-icon.svg",
          iconClass: "hkfi-edit fs-16 color-slaty",
        },
        {
          label: "Delete",
          labelMethod: (item) => {
            this.handleDeleteClick(item);
          },
          iconSrc: staticImgBaseUrl + "/images/global/delete-icon.svg",
          iconClass: "hkfi-delete fs-16 color-slaty",
        },
      ];
    },
    checkDeliveryTypeIsD() {
      let selectedDeliveryType = LocalStorageFunc.getSelectedDeliveryType();
      let deliveryTypeOfSelectedStore = LocalStorageFunc.getDeliveryType();
      return selectedDeliveryType.length
        ? selectedDeliveryType == OrderTypesCode.DELIVERY_CODE
        : deliveryTypeOfSelectedStore == OrderTypesCode.DELIVERY_CODE;
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    isChangeTriggeredFromTakeawayDinein() {
      let queryParams = Utility.getQueryFromUrl();
      return queryParams["changeTriggerFromDineinTwy"] == "true" || false;
    },
    isInvalidSearchInput() {
      return this.$store.state.Location.autoCompleteInvalidInput;
    },
    currentLocationCoords() {
      let currentGPSLocation =
        LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;
      if (!currentGPSLocation) {
        let currentLocationFromStorage =
          LocalStorageFunc.getCoordsFromRecentLocation()?.coords;

        return this.$store.state.Location.currentLocation?.lat
          ? this.$store.state.Location.currentLocation
          : currentLocationFromStorage
          ? {
              lat: currentLocationFromStorage.latitude,
              lng: currentLocationFromStorage.longitude,
            }
          : {};
      } else {
        return currentGPSLocation;
      }
    },
    noSavedAddressDetails() {
      return typeof this.modulePropsData?.noSavedAddressDetails === "string"
        ? JSON.parse(this.modulePropsData?.noSavedAddressDetails)
        : this.modulePropsData?.noSavedAddressDetails;
    },
    noSavedAddressHeadingText() {
      return this.isLoggedIn
        ? this.noSavedAddressDetails?.headingText ||
            LocationPageStaticKeys.noSavedAddressDetails?.headingText
        : this.noSavedAddressDetails?.guestUserHeadingText ||
            LocationPageStaticKeys.noSavedAddressDetails?.guestUserHeadingText;
    },
    noSavedAddressCTAText() {
      return this.isLoggedIn
        ? this.noSavedAddressDetails?.ctaText ||
            LocationPageStaticKeys.noSavedAddressDetails?.ctaText
        : this.noSavedAddressDetails?.guestUserCtaText ||
            LocationPageStaticKeys.noSavedAddressDetails?.guestUserCtaText;
    },
    noSavedAddressImgUrl() {
      let iconUrl = this.noSavedAddressDetails
        ? this.noSavedAddressDetails?.iconImageURL
        : LocationPageStaticKeys.noSavedAddressDetails?.iconImageURL;
      return iconUrl;
    },
    invalidSearchResultsDetails() {
      return typeof this.modulePropsData?.invalidSearchResultsDetails ===
        "string"
        ? JSON.parse(this.modulePropsData?.invalidSearchResultsDetails)
        : this.modulePropsData?.invalidSearchResultsDetails;
    },
    invalidSearchResultsDetailsNoLocationsSubtitle() {
      return (
        this.invalidSearchResultsDetails?.noLocationsSubtitle ||
        LocationPageStaticKeys.invalidSearchResultsDetails?.noLocationsSubtitle
      );
    },
    invalidSearchResultsDetailsNoLocationsTitle() {
      return (
        this.invalidSearchResultsDetails?.noLocationsTitle ||
        LocationPageStaticKeys.invalidSearchResultsDetails?.noLocationsTitle
      );
    },
    invalidSearchResultsDetailsCtaText() {
      return (
        this.invalidSearchResultsDetails?.ctaText ||
        LocationPageStaticKeys.invalidSearchResultsDetails?.ctaText
      );
    },
    invalidSearchResultsDetailsCtaIcon() {
      return (
        this.invalidSearchResultsDetails?.ctaIcon ||
        LocationPageStaticKeys.invalidSearchResultsDetails?.ctaIcon
      );
    },
    invalidSearchResultsDetailsNoLocationImage() {
      return (
        this.invalidSearchResultsDetails?.noLocationImage ||
        LocationPageStaticKeys.invalidSearchResultsDetails?.noLocationImage
      );
    },
    getIsAddEditAddressFlow() {
      return LocalStorageFunc.getIsAddEditAddressFlow();
    },
  },
};
</script>
